var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBacklog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.917 15c.598 0 1.083.537 1.083 1.2v3.6c0 .663-.485 1.2-1.083 1.2H1.083C.485 21 0 20.463 0 19.8v-3.6c0-.663.485-1.2 1.083-1.2h10.834zm0 1.2H1.083v3.6h10.834v-3.6zM16.923 8C17.518 8 18 8.537 18 9.2v3.6c0 .663-.482 1.2-1.077 1.2H5.077C4.482 14 4 13.463 4 12.8V9.2C4 8.537 4.482 8 5.077 8h11.846zm0 1.2H5.077v3.6h11.846V9.2zm3.035-7.711l.131 1.01-1.826.02 4.302 3.74c.898.78 1.063 2.06.37 2.858l-3.157 3.63-.812-.706 3.156-3.63a.907.907 0 00.206-.718 1.149 1.149 0 00-.391-.711l-4.302-3.74.234 1.811-1.02.012-.39-3.031a.453.453 0 01.102-.36.453.453 0 01.341-.151l3.056-.034zM11.917 0C12.515 0 13 .537 13 1.2v3.6c0 .663-.485 1.2-1.083 1.2H1.083C.485 6 0 5.463 0 4.8V1.2C0 .537.485 0 1.083 0h10.834zm0 1.2H1.083v3.6h10.834V1.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklog);
export default __webpack_public_path__ + "static/media/backlog.de41973e.svg";
export { ForwardRef as ReactComponent };